/* eslint-disable camelcase */
const type_backlog = 'backlog';
const type_doing = 'doing';
const type_blocked = 'blocked';
const type_done = 'done';
const type_ready = 'ready';
const type_review = 'review';

export { type_backlog, type_blocked, type_doing, type_done, type_ready, type_review };
// eslint-disable-next-line prettier/prettier
